import {ordoroFetch} from './ordoroFetch.js'
import {stringify} from './querystring.js'

const VERDE_URL = '/verde'

export function formatVerdeURL(url, query) {
  return `${VERDE_URL}${url}${query ? `?${stringify(query)}` : ''}`
}

export function verdeFetch(method, url, data, options) {
  return ordoroFetch(
    method,
    formatVerdeURL(url, method === 'get' && data),
    data,
    options,
  )
}

export default {
  head(url, data, options) {
    return verdeFetch('head', url, data, options)
  },
  get(url, data, options) {
    return verdeFetch('get', url, data, options)
  },
  put(url, data, options) {
    return verdeFetch('put', url, data, options)
  },
  post(url, data, options) {
    return verdeFetch('post', url, data, options)
  },
  patch(url, data, options) {
    return verdeFetch('patch', url, data, options)
  },
  delete(url, data, options) {
    return verdeFetch('delete', url, data, options)
  },
}
